import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var post_author_default = /* @__PURE__ */ jsx(SVG, { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
  Path,
  {
    d: "M10 4.5a1 1 0 11-2 0 1 1 0 012 0zm1.5 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2.25 7.5v-1A2.75 2.75 0 0011 8.25H7A2.75 2.75 0 004.25 11v1h1.5v-1c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1h1.5zM4 20h9v-1.5H4V20zm16-4H4v-1.5h16V16z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
) });
export {
  post_author_default as default
};
//# sourceMappingURL=post-author.js.map
